import { render, staticRenderFns } from "./drawer-collection.vue?vue&type=template&id=7731e5a0&"
import script from "./drawer-collection.vue?vue&type=script&lang=js&"
export * from "./drawer-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports